// Polyfills

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function(con) {
  'use strict';
  var prop, method;
  var empty = {};
  var dummy = function() {};
  var properties = 'memory'.split(',');
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,' +
     'table,time,timeEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) con[prop] = con[prop] || empty;
  while (method = methods.pop()) con[method] = con[method] || dummy;
})(this.console = this.console || {});


if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== "function") {
      // closest thing possible to the ECMAScript 5 internal IsCallable function
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () {},
        fBound = function () {
          return fToBind.apply(this instanceof fNOP && oThis
                                 ? this
                                 : oThis,
                               aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}


// Initialize Namespace
var BOO = BOO || {};
BOO.namespace = function (ns_string) {
  var parts = ns_string.split('.'),
      parent = BOO,
      i;

  if (parts[0] === "BOO")
    parts = parts.slice(1);

  for (i = 0; i < parts.length; i++) {
    if (typeof parent[parts[i]] === "undefined")
      parent[parts[i]] = {};
    parent = parent[parts[i]];
  }
  return parent;
};

/*
 * Page Views
 */

// All
BOO.namespace('BOO.views.global');
BOO.views.global = (function () {
  return {
    initialize: function () {
      BOO.views.footer.initialize();
      BOO.views.stickyNav.initialize();
      BOO.svg.initialize();

      // Wishlist Stuff (doesn't have it's own JS)
      if ( $('table#wishlist-table').length > 0 ) {
        if (window.WISHLIST_URL) {
          $('#wishlist-permalink').attr('href', window.WISHLIST_URL);
        } else {
          $('.small-header').text("This is a Band of Outsiders Wishlist");
        }
      }

    }
  }
}());

// Index
BOO.namespace('BOO.views.index');
BOO.views.index = (function () {
  return {
    initialize: function () {
      BOO.views.homepageCarousel.initialize();
      BOO.views.homepageNavBar.initialize();
      BOO.views.feed.initialize();
    }
  }
}());

// Product
BOO.namespace('BOO.views.product');
BOO.views.product = (function () {
  return {
    initialize: function () {
      $('.product-image-list').each(function () {
        BOO.views.productImageSelector.initialize(this);
      });
      $('.dropdown.select').each(function () {
        new BOO.views.dropdown(this);
      });

      BOO.views.fromTheArchive.initialize();
      BOO.views.shareButton.initialize();
      BOO.views.sizeChartModal.initialize();

      if (window != window.top) {
        $('.left-col').css('padding-top', '80px');
      }
    }
  }
}());

// Collection
BOO.namespace('BOO.views.collection');
BOO.views.collection = (function () {
  return {

    normalizeRows: function () {
      var container = document.getElementById('product-grid');
      imagesLoaded(container, function () {
        // Adjust Row Heights
        $('.product-grid-row').each(function () {
          $('.prod-image-wrap', this);
          var largestProductImageHeight = Math.max( $('.prod-image-wrap', this).first().height(), $('.prod-image-wrap', this).last().height() );
          $('.prod-image-wrap', this).height(largestProductImageHeight);
        });
        // Adjust Images inside the Rows (doing this with CSS caused some problems)
        $(".prod-image-wrap a img").each(function () {
          var imageHeight = $(this).height();
          var $container = $(this).parents('.prod-image-wrap');
          var containerHeight = $container.height();
          var marginTop = (containerHeight - imageHeight) / 2;
          $(this).css('margin-top', marginTop);
          $container.height( containerHeight - marginTop ); // remove extra bottom space
        });
      });
    },

    initialize: function () {
      $('.dropdown.filter, .dropdown.sort').each(function () {
        new BOO.views.collectionDropdown(this);
      });
      BOO.events.quickLook.initialize();
      this.normalizeRows();
    }
  }
}());

// Account
// Homepage Nav Bar
BOO.namespace("BOO.views.account")
BOO.views.account = (function () {
  return {
    initialize: function () {
      $('.is-password-field').on('focus', function () {
        $(this).attr('type', 'password');
      });
      $('.input input').on('focus', function () {
        $(this).css('color', '#000');
      }).on('blur', function () {
        if ($(this).val() === $(this).attr('placeholder')) {
          $(this).css('color', '#888');
        }
      });

      // Prefilled fields:
      $('.input input').each(function () {
        if ($(this).val() != $(this).attr('placeholder') && $(this).val() != "") {
          $(this).css('color', '#000');
        }
      });

      // flag user if they are on reg page w/ checkout_url in url, and click create account
      $('form#create_customer').on('submit', function () {
        if (window.location.href.match('checkout_url') !== null && localStorage) {
          localStorage['customer_intends_to_check_out_after_account_creation'] = "true";
        }
      });
      if (localStorage && localStorage['customer_intends_to_check_out_after_account_creation'] === "true" && window.location.pathname === "/account") {
        localStorage['customer_intends_to_check_out_after_account_creation'] = '';
        window.location.href = "/checkout";
      }
    }
  }
}());

// Cart
BOO.namespace("BOO.views.cart")
BOO.views.cart = (function () {
  return {
    initialize: function () {
      // $('.dropdown.quantity').each(function () {
      //   new BOO.views.quantityDropdown(this);
      // });
      $('input[name="updates[]"]').on('blur', function () {
        $('#update-cart').trigger('click');
      })
    }
  }
}());



/*
 * Subviews
 */

// Sticky Nav
BOO.namespace('BOO.views.stickyNav');
BOO.views.stickyNav = (function () {
  return {

    initialize: function () {
      if (window!=window.top) {
        $('footer.shifted, .top-nav.shifted').remove();
      } else {
        if ($('body').hasClass('template-index')) {
          // Special Homepage Behavior
          var $homepageNav = $('.homepage-nav');
          var $navs = $('.top-nav, footer');
          $(window).scroll(function () {
            var offset = $homepageNav.offset().top + $homepageNav.height();
            if ($(window).scrollTop() > offset) {
              $navs.addClass('shouldAnimate').removeClass('shifted');
            } else {
              // Hide them
              $('body').removeClass('expanded-footer');
              $navs.addClass('shifted');
            }
          });
        } else {
          $('.top-nav, footer').removeClass('shifted');
        }
      }

      if (window.CURRENT_COLLECTION_HANDLE) {
        // We're on a collection page -- update the nav
        if (window.CURRENT_COLLECTION_HANDLE.match(/womens/)) {
          $('#womens-nav-item').addClass('active');
        } else if (window.CURRENT_COLLECTION_HANDLE.match(/mens/)) {
          $('#mens-nav-item').addClass('active');
        }
      } else {
        // Check if any of the nav items match part of current url (and is not "/")
        $('.top-nav .nav-items a').each(function () {
          var href = $(this).attr('href');
          if (href && href !== "/" && window.location.pathname.match(href)) {
            $(this).addClass('active');
          } else {
            if (window.location.pathname === "/") { // FEED
              $('#feed-nav-item').addClass('active');
            }
          }

        });
      }

    }
  }
}());

// Homepage Nav Bar
BOO.namespace("BOO.views.homepageNavBar")
BOO.views.homepageNavBar = (function () {
  return {
    adjustTopMargin: function () {
      var $hc = $('.homepage-carousel'),
          $hn = $('.homepage-nav'),
          bottomOfCarouselOffset = $hc.offset().top + $hc.height(),
          heightOfNav = $('.homepage-nav').height(),
          newMarginTop = $(window).height() - bottomOfCarouselOffset - heightOfNav;
          $hn.css("margin-top", newMarginTop);
    },
    initialize: function () {
      // On resize, make sure we're 0 px from bottom,
      // But don't use position:fixed or position: absolute, as
      // it will affect rendering of rest of page
      $(window).on('resize', this.adjustTopMargin);
      this.adjustTopMargin();
    }
  }
}());

// Homepage Carousel
BOO.namespace("BOO.views.homepageCarousel")
BOO.views.homepageCarousel = (function () {
  return {
    currentIndex: 0,
    carouselImages: (function () {
      return [ // TODO: use settings length
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_1.jpg?v=56485459792097734291408732639",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_2.jpg?v=47189083649253471571408732643",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_3.jpg?v=179913207430397353541408732647",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_4.jpg?v=132937541002559312971408732650",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_5.jpg?v=126022966181429784381408732652",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_6.jpg?v=148270880829996610781408732657",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_7.jpg?v=180865321134048958021407852383",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_8.jpg?v=168613033407044855201407852389",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_9.jpg?v=84838717951812854491407852393",
        "//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_10.jpg?v=11",
      ].splice(0, 1)
    }()),
    initializeImages: function () {
      $('.homepage-carousel .image').css({
        'background-image': 'url(' + this.carouselImages[this.currentIndex] + ')'
      });
    },
    next: function () {
      var _this = this;
      this.currentIndex = (this.currentIndex + 1) % this.carouselImages.length;

      var $currentImage = $('.homepage-carousel .image');
      var $newImage = $("<div class='image right'></div>").css({
          'background-image': 'url(' + _this.carouselImages[_this.currentIndex] + ')'
      })
      var $roll = $('.homepage-carousel .image-roll');

      $roll.append($newImage);
      this.resizeToFitPage();
      $roll.animate({
        left: -1 * $currentImage.width()
      });

      setTimeout(function () {
        $('.homepage-carousel .image-roll').css('left', '0');
        $currentImage.remove();
      }, 900);
    },
    prev: function () {
      var _this = this;
      if (this.currentIndex == 0) {
        this.currentIndex = this.carouselImages.length - 1
      } else {
        this.currentIndex = this.currentIndex - 1;
      }
      var $currentImage = $('.homepage-carousel .image');
      var $newImage = $("<div class='image right'></div>").css({
          'background-image': 'url(' + _this.carouselImages[_this.currentIndex] + ')'
      })
      var $roll = $('.homepage-carousel .image-roll');

      $roll.css('left', -1 * $currentImage.width()).prepend($newImage);
      this.resizeToFitPage();
      $roll.animate({
        left: 0
      });

      setTimeout(function () {
        $currentImage.remove();
      }, 900);
    },
    resizeToFitPage: function () {
      var MAX_HEIGHT_WIDTH = 800;

      var carouselHeight = (function () {
        var h = Math.min( ($(window).height() - $('.homepage-carousel').offset().top - $('.homepage-nav').height()), $(window).width());
        return Math.min( h, MAX_HEIGHT_WIDTH );
      }());
      var containerHeight = (function () {
        return carouselHeight - 55;
      }());

      $('.homepage-carousel').height(carouselHeight)
      .find('.image-container')
        .height(containerHeight) // 55px of padding on bottom
        .width(containerHeight)
      .find('.image-roll').height(containerHeight).width(function () {
        return containerHeight * 1;
      }).find('.image').height(containerHeight).width(containerHeight);

    },
    cleanAssetUrl: function (asset_url) {
      if (asset_url.indexOf("?") > -1)
        asset_url = asset_url.split('?')[0];
      return asset_url
    },
    preloadImages: function () {
      var image_1 = this.cleanAssetUrl("//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_arrow_left_hover.png?v=170315421431387634311386798240");
      var image_2 = this.cleanAssetUrl("//jason-dev-shop.myshopify.com/cdn/shop/t/1/assets/img_carousel_arrow_right_hover.png?v=50104415687393614711386798244");
      var imageList = [image_1, image_2].concat(this.carouselImages);
      for (var i = 0; i < imageList.length; i++) {
        var img = new Image();
        img.src = imageList[i];
      }
    },
    bindEvents: function () {
      $('.homepage-carousel .arrow.right').on('click', _.throttle(this.next.bind(this), 1000));
      $('.homepage-carousel .arrow.left' ).on('click', _.throttle(this.prev.bind(this), 1000));
    },
    hideArrows: function() {
        if (this.carouselImages.length == 1) {
            $('.homepage-carousel > .left').hide();
            $('.homepage-carousel > .right').hide();
        }
    },
    initialize: function () {
      $(window).on('resize', this.resizeToFitPage);
      this.resizeToFitPage();
      this.preloadImages();
      this.initializeImages();
      this.hideArrows();
      this.bindEvents();

    }
  }
}());

// Footer
BOO.namespace("BOO.views.footer")
BOO.views.footer = (function () {
  return {
    initialize: function () {
      $('footer .message').on('click', function (e) {
        $('body').toggleClass('expanded-footer');
      });
    }
  }
}());

// Feed
BOO.namespace("BOO.views.feed")
BOO.views.feed = (function () {
  return {
    items_per_page: 20,
    page_number: 0,
    loading: false,
    masonry: null,
    initMasonry: function () {
      var container = document.querySelector('#feed-container');
      var msry = new Masonry(container, {
        columnWidth: 275,
        gutter: 77,
        //itemSelector: ".feed-item"
        visibleStyle: { opacity: 1},
        hiddenStyle: { opacity: 0},
      });
      msry.on('layoutComplete', this.postProcessItems);
      imagesLoaded(container, function () {
        msry.reloadItems();
      });
      this.masonry = msry;
    },
    startLoading: function () {
      if (this.loading === true) return;
      this.loading = true;
      $('#feed-container').after('<div class="loading">Loading<span>...</span></div>');
    },
    endLoading: function () {
      if (this.loading === false) return;
      this.loading = false;
      $('.loading').remove();
      if (this.page_number == 1 && window.location.hash === "#feed") {
        // scroll down if user got to this page via /#feed
        setTimeout(this.scrollToFeed, 500)
      }
      this.postProcessItems();
      $(document).trigger("infiniteScrollPageLoaded");
    },
    postProcessItems: function (msnryInstance, laidOutItems) {
      if (laidOutItems) {
        for (var i = 0; i < laidOutItems.length; i++) {
          var item = laidOutItems[i];
          var $e = $(item.element);
          // Make twitter items load in new window
          $e.find('.feed-tweet a').each(function () {
            $(this).attr('target', '_blank');
          })
        }
      }
    },
    addPage: function (cb) {
      _this = this;
      if (_this.loading) {
        return;
      } else {
        _this.startLoading();
      }
      var offset = _this.page_number * _this.items_per_page;
      var url = "//api.tumblr.com/v2/blog/bandfeed.tumblr.com/posts?api_key=yi10s61ySYY0AZq18NzNMG9e6aoE08lnAm5VrPMNkC3X2OZ4Gb&offset=" + offset;
      $.ajax(url, {
        dataType: 'jsonp',
        jsonp: "jsonp",
        success: function (root) {
          if (root.meta.status === 200) {
            _this.page_number++;

            var $htmlFragment = $('<div></div>');
            var nodeList = [];

            _.each(root.response.posts, function (post) {
              var $html = $(_this.templates[post.type](post));
              $htmlFragment.append($html);
              nodeList.push($html.get(0));
            });

            var imgLoad = imagesLoaded($htmlFragment);

            imgLoad.on('always', function () {
              $('#feed-container').append($htmlFragment.html());
              _this.masonry.appended($('#feed-container .feed-item.new'));
              $('#feed-container .feed-item.new').removeClass('new');
              _this.endLoading();
            });
          } else {
            _this.endLoading();
          }
        }
      });
    },
    scrollToFeed: function () {
      var pxToFeed = $('#feed-container').offset().top + 10; // 10 -> to trigger header
      window.scrollTo(0, pxToFeed);
    },
    shareOnTumblr: function (image_url, caption, tags) {
      window.open("http://www.tumblr.com/share/photo?source=" + encodeURIComponent( image_url ) + "&caption=" + encodeURIComponent( caption ) + "&clickthru=" + encodeURIComponent( window.location.href ) + "&tags=" + encodeURIComponent(tags),'sharer','toolbar=0,status=0,width=480,height=480');
    },
    shareOnTwitter: function (text, tags) {
      window.open('http://twitter.com/intent/tweet?url='+encodeURIComponent(window.location.href)+'&related=bandofoutsiders' + '&text=' + encodeURIComponent( text ) + '&hashtags=' + encodeURIComponent( tags ),'sharer','toolbar=0,status=0,width=480,height=480');
    },
    initialize: function () {
      var _this = this;
      // HTTPS -> HTTP redirect if necessary (for vimeo)
      if (window.location.href.match(/https:/) !== null) {
        window.location.href = window.location.href.replace('https://', 'http://');
      }
      this.initMasonry();
      this.templates = {
        "photo": Handlebars.compile($('#feed-photo-template').html()),
        "text": Handlebars.compile($('#feed-text-template').html()),
        "quote": Handlebars.compile($('#feed-quote-template').html()),
        "link": Handlebars.compile($('#feed-link-template').html()),
        "answer": Handlebars.compile($('#feed-answer-template').html()),
        "video": Handlebars.compile($('#feed-video-template').html()),
        "audio": Handlebars.compile($('#feed-audio-template').html()),
        "chat": Handlebars.compile($('#feed-chat-template').html()),
      },
      this.addPage();
      $(window).scroll(_.debounce(function() {
        if(($(window).scrollTop() + $(window).height()) / $(document).height() > 0.8) {
          //console.log("at 80%");
          _this.addPage();
        }
      }, 250));
      // use JS to process /#feed hash, because there's some bugs using an <a>
      $(window).on('hashchange', function () {
        if (window.location.hash === "#feed")
          _this.scrollToFeed();
      });

      // Bind share button
      $('#feed-container').on('click', '.share.photo', function () {
        var sharePhotoUrl = $(this).attr('data-shareable-photo-url');
        var caption = $(this).siblings('.caption').find('p').text();
        var tags = "bandofoutsiders";
        _this.shareOnTumblr(sharePhotoUrl, caption, tags);
      });
      $('#feed-container').on('click', '.share.text', function () {
        var text = $(this).siblings('.body').find('.feed-tweet').text();
        var tags = "bandofoutsiders";
        _this.shareOnTwitter(text, tags);
      });

      $(document).on("addPage", function (event) {
        _this.addPage.bind(_this)();
      });

      // Modal
      BOO.events.feedDetail.initialize();
    }
  }
}());


// Archive
BOO.namespace("BOO.views.archive")
BOO.views.archive = (function () {
  return {
    items_per_page: 20,
    page_number: 0,
    loading: false,
    masonry: null,
    currentTag: "",
    initMasonry: function () {
      var container = document.querySelector('#archive-container');
      var msry = new Masonry(container, {
        columnWidth: 320,
        gutter: 75,
        //itemSelector: ".archive-item"
        visibleStyle: { opacity: 1},
        hiddenStyle: { opacity: 0},
      });
      imagesLoaded(container, function () {
        msry.reloadItems();
      });
      this.masonry = msry;
    },
    startLoading: function () {
      if (this.loading === true) return;
      this.loading = true;
      $('#archive-container').after('<div class="loading">Loading<span>...</span></div>');
    },
    endLoading: function () {
      if (this.loading === false) return;
      this.loading = false;
      $('.loading').remove();
       $(document).trigger("infiniteScrollPageLoaded");
    },
    reset: function () {
      this.page_number = 0;
      this.masonry.remove( $('#archive-container *') );
    },
    addPage: function (cb) {
      _this = this;
      if (_this.loading) {
        return;
      } else {
        _this.startLoading();
      }
      console.log("Adding page " + _this.page_number);
      var offset = _this.page_number * _this.items_per_page;
      var url = "http://api.tumblr.com/v2/blog/booarchive.tumblr.com/posts?api_key=yi10s61ySYY0AZq18NzNMG9e6aoE08lnAm5VrPMNkC3X2OZ4Gb&offset=" + offset + "&tag=" + _this.currentTag;
      $.ajax(url, {
        dataType: 'jsonp',
        jsonp: "jsonp",
        success: function (root) {
          if (root.meta.status === 200) {
            _this.page_number++;

            var $htmlFragment = $('<div></div>');
            var nodeList = [];

            _.each(root.response.posts, function (post) {
              if (post.type == "photo") {
                var $html = $(_this.templates[post.type](post));
                $htmlFragment.append($html);
                nodeList.push($html.get(0));
              }
            });

            var imgLoad = imagesLoaded($htmlFragment);

            imgLoad.on( 'always', function () {
              $('#archive-container').append($htmlFragment.html());
              _this.masonry.appended($('#archive-container .archive-item.new'));
              $('#archive-container .archive-item.new').removeClass('new');
              _this.endLoading();
            });
          }
        }
      });
    },
    filterByTag: function (tag) {
      console.log("filtering by ", tag);
      $('.tc-link').each(function () {
        if ($(this).text() === tag) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
      if (tag == "everything") tag = "";
      window.location.hash = tag;
      this.reset();
      this.currentTag = tag;
      this.addPage();
      this.masonry.layout();
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    bindEvents: function () {
      var _this = this;
      $('#tag-list').on('click', 'a', function (e) {
        e.preventDefault();
        _this.filterByTag( $(this).text() );
        return false;
      });
      $('#archive-container').on('click', '.tags a', function () {
        _this.filterByTag($(this).text().slice(1));
      });
      // Expose a global event hook
      $(document).on("filterByTag", function (event, tag) {
        _this.filterByTag.bind(_this)(tag)
      });
      $(document).on("addPage", function (event) {
        _this.addPage.bind(_this)();
      });
    },

    initialize: function () {
      var _this = this;

      BOO.events.archiveDetail.initialize();

      // HTTPS -> HTTP redirect if necessary (for tag cloud)
      if (window.location.href.match(/https:/) !== null) {
        window.location.href = window.location.href.replace('https://', 'http://');
      }
      this.bindEvents();
      $('.tc-link').livequery(function () {
        $(this).attr('href', '#' + $(this).text());
      });
      this.initMasonry();
      this.templates = {
        "photo": Handlebars.compile($('#archive-template').html()),
      };
      if (window.location.hash !== "") {
        this.filterByTag(window.location.hash.split('#')[1]);
      }
      this.addPage();
      $(window).scroll(_.debounce(function() {
        var bottomOfPageOffset = $(window).scrollTop() + $(window).height();
        if( bottomOfPageOffset / $(document).height() > 0.8) {
          _this.addPage();
        } else {
          // Check if we're not at bottom but beyond end of #archive-container
          var $archive = $('#archive-container');
          if ($archive.offset().top + $archive.height() < bottomOfPageOffset - 600) {
            _this.addPage();
          }
        }
      }, 250));
    }
  }
}());

// "From the Archive" area
BOO.namespace("BOO.views.fromTheArchive");
BOO.views.fromTheArchive = (function () {

  return {

    ignoredTags: [
      'button-ups',
      'polos-ts-sweats',
      'sweaters',
      'trousers',
      'shorts',
      'blazers-suits',
      'coats-jackets',
      'accessories',
      'dresses',
      'tops',
      'blazers',
      'pants-jumpsuits',
      'skirts-shorts'
    ],

    tags: [],

    renderImage: function (url, tag) {
      console.log("in renderImage");
      $('.from-the-archive .image').html("<img src='" + url + "' />").on('click', function () {
        window.location.href = "/pages/archive#" + tag;
      });
    },

    getArchiveItemsForTag: function (tag) {
      var dfd = jQuery.Deferred();
      var _this = this;
      var url = "http://api.tumblr.com/v2/blog/booarchive.tumblr.com/posts/photo?api_key=yi10s61ySYY0AZq18NzNMG9e6aoE08lnAm5VrPMNkC3X2OZ4Gb&offset=0&tag=" + tag;
      $.ajax(url, {
        dataType: 'jsonp',
        jsonp: "jsonp",
        success: function (data) {
          if (data.meta.msg == "OK") {
            var posts = data.response.posts;
            if (posts.length > 0) {
              var post = _.sample(posts);
              var photo = post.photos[0];
              var sizedPhoto = _.where(photo.alt_sizes, {width: 250});
              if (sizedPhoto.length > 0) {
                var photoUrl = sizedPhoto[0].url;
                _this.renderImage(photoUrl, tag);
                dfd.resolve();
              } else {
                dfd.reject();
              }
            } else {
              dfd.reject();
            }
          } else {
            dfd.reject();
          }
        }
      });
      return dfd;
    },

    tryToRenderNextTag: function () {
      var _this = this;
      //debugger;
      if(_this.tags.length > 0) {
        _this.getArchiveItemsForTag( _this.tags.shift() ).fail(_this.tryToRenderNextTag.bind(_this))
      } else {
        _this.getArchiveItemsForTag('bandofoutsiders');
        //$('.from-the-archive').remove();
      }
    },

    initialize: function () {
      var _this = this;

      $('.from-the-archive .tags a').each(function () {
        _this.tags.push( $(this).text().split('#')[1] );
      });

      // Shuffle tags
      _this.tags = _.shuffle(_this.tags);

      // Remove ignored tags from list
      this.tags = _.difference(this.tags, this.ignoredTags);
      $('.from-the-archive a').each(function () {
        var tag = $(this).text().split('#')[1];
        if ( _.indexOf(_this.ignoredTags, tag) > -1 ) {
          $(this).remove();
        }
      });

      console.log("fromTheArchive using tags =", this.tags)

      this.tryToRenderNextTag();

    }

  }

}());

// Share Button
BOO.namespace("BOO.views.shareButton")
BOO.views.shareButton = (function () {
  return {
    tags: function () {
      var tagString = "bandofoutsiders";
      $('.module.from-the-archive .tags a').each(function () {
        tagString += "," + $(this).text().split('#')[1];
      });
      return tagString;
    },
    imageUrl: function () {
      return $('#main-product-image img').attr('src');
    },
    caption: function () {
      return $('.module.information .name').text();
    },
    shareOnTumblr: function () {
      window.open("http://www.tumblr.com/share/photo?source=" + encodeURIComponent( this.imageUrl() ) + "&caption=" + encodeURIComponent( this.caption() ) + "&clickthru=" + encodeURIComponent( window.location.href ) + "&tags=" + encodeURIComponent(this.tags()),'sharer','toolbar=0,status=0,width=480,height=480');
      this.closeModal();
      return false;
    },
    shareOnTwitter: function () {
      window.open('http://twitter.com/intent/tweet?url='+encodeURIComponent(window.location.href)+'&related=bandofoutsiders' + '&text=' + encodeURIComponent( this.caption() ) + '&hashtags=' + encodeURIComponent( this.tags() ),'sharer','toolbar=0,status=0,width=480,height=480');
      this.closeModal();
      return false;
    },
    shareOnFacebook: function () {
      window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(window.location.href),'sharer','toolbar=0,status=0,width=480,height=480');
      this.closeModal();
      return false;
    },
    openModal: function () {
      var _this = this;
      $('body').append('<div class="dimmer"></div>');
      $('#share-modal').show();
      $('.dimmer, #share-modal').one('click', function (e) {
        if (! $(e.target).hasClass('inner'))
          _this.closeModal();
      });
      $('#share-modal').get(0).scrollIntoView();
    },
    closeModal: function () {
      $('.dimmer').remove();
      $('#share-modal').hide();
    },
    initialize: function () {
      $('.share').on('click', this.openModal.bind(this));
      $('#share-modal .tumblr').on('click',   this.shareOnTumblr.bind(this));
      $('#share-modal .twitter').on('click',  this.shareOnTwitter.bind(this));
      $('#share-modal .facebook').on('click', this.shareOnFacebook.bind(this));
    }
  }
}());

// Stores Selector
BOO.namespace("BOO.views.stores")
BOO.views.stores = (function () {
  return {

    data:          [],
    activeFilters: {},
    $selector:     null,
    inputFieldNames:    ['who', 'name', 'address', 'city', 'state', 'country', 'phone', 'url'],
    outputFieldNames:   ['who', 'country', 'state', 'city', 'name'],

    filteredData: function () {

      var _this = this;

      var activeFilterKeys = (function () {
        var keys = [];
        for (var property in _this.activeFilters) {
          if (_this.activeFilters.hasOwnProperty(property) && _this.activeFilters[property] !== null) {
            keys.push(property)
          }
        }
        return keys;
      }());

      console.log("activeFilterKeys:", activeFilterKeys);

      return _.filter(this.data, function (store) {
        for (var property in store) {
          if (store.hasOwnProperty(property) && activeFilterKeys.indexOf(property) > -1) {
            // Filter on this property
            // uncomment the following if BOTH means EITHER
            if ( /* _this.activeFilters[property] !== "BOTH" && */ store[property] !== _this.activeFilters[property]) {
              return false;
            }
          }
        }
        return true;
      });
    },

    processClick: function (event) {
      //if (event.originalEvent && event.originalEvent.toElement) {
        var $linkClicked = $(event.currentTarget);
        this.processLinkClicked($linkClicked);
      //}
    },

    processLinkClicked: function ($linkClicked) {
      var filterKey    = $linkClicked.siblings('.head').text();
      var filterValue  = $linkClicked.attr('data-value');
      var currentIndex = $linkClicked.parents('.column').index()
      this.activeFilters[filterKey] = filterValue;

      // console.log("this.activeFilter:", this.activeFilters);
      // console.log("this.filteredData():", this.filteredData());
      // console.log("this.filteredData().length:", this.filteredData().length);
      // console.log("currentIndex", currentIndex );

      $linkClicked.siblings().removeClass('active')
      $linkClicked.addClass('active');

      for (var i = currentIndex + 1; i < this.outputFieldNames.length + 1; i++) {
        // Clear out following column filters
        console.log("clearing: ", this.outputFieldNames[i]);
        this.activeFilters[this.outputFieldNames[i]] = null;
        // Clear out following column UI
        this.$selector.find('.column:eq(' + i + ')').removeClass('visible');
      }

      // Render the next list
      this.setupColumn(currentIndex + 1);
    },

    uniqueValuesForKey: function (key) {
      return _.uniq(_.pluck(this.filteredData(), key));
    },

    setupColumn: function (index) {
      var $col = this.$selector.find('.column:eq(' + index + ')');
      if (index <= 4) {
        var options = this.uniqueValuesForKey(this.outputFieldNames[index]);
        $col.html('<div class="section"><div class="head">' + this.outputFieldNames[index] + '</div></div>')
        for (var i=0; i<options.length; i++) {
//          var prettyName = options[i].toProperCase();
          var prettyName = options[i];
          $col.find('.section').append('<a href="#" data-value="' + options[i] + '" >' + prettyName + "</a>");
        }
        $col.addClass('visible');

        // Check if there's only one option, if so, go ahead and open it
        console.log("$col.find('.section a').length = ", $col.find('.section a').length);
        if ($col.find('.section a').length == 1) {
          this.processLinkClicked($col.find('.section a').first());
        }

      } else {
        // Detail aka store data view
        var storeList = _.where(this.filteredData(), {name: this.activeFilters.name});
        if (storeList.length > 0) {
          var storeData= storeList[0];
          console.log("storeData = ", storeData);
          $col.html('<div class="section"><div class="head">Information</div></div>');
          if (storeData.address !== "N/A") {
            $col.append('<p>' + storeData.address + '</p>');
          }
          if (storeData.phone !== "N/A") {
            $col.append('<p>' + storeData.phone + '</p>');
          }
          if (storeData.url !== "N/A") {
            $col.append('<p><a href="' + storeData.url + '" target="_blank">' + storeData.url + '</a></p>');
          }
          $col.addClass("visible");
        }
      }
    },

    processStoreData: function () {
      //this.data = window.STORE_DATA; //$.csv.toArrays(result);
      // convert from ["MENS", "BLU JE BLUE", "", ... ""] to {'who': 'MENS', store: 'foo'}
      for (var i = 0; i < window.STORE_DATA.length; i++) {
        for (var j = 0; j < window.STORE_DATA[i].length; j++) {
          // change "" to "N/A"
          if (window.STORE_DATA[i][j] === "") window.STORE_DATA[i][j] = "N/A";
        }
        this.data.push( _.object(this.inputFieldNames, window.STORE_DATA[i]) );
      }

    },

    initialize: function () {
      this.$selector = $('#store-selector');
      this.$selector.on('click', '.section a', this.processClick.bind(this));
      this.processStoreData();
      this.setupColumn(0);
    }

  }
}());

// Project Page
BOO.namespace("BOO.views.project")
BOO.views.project = (function () {
  return {

    setCSS: function () {

      $('#page-content table').each(function (index) {
        var usedSpace = 100 + $(this).height();
        var unUsedSpace = $(window).height() - usedSpace;
        var margin = Math.max(10, unUsedSpace / 2);
        $(this).css({
          'margin-top': margin + "px",
          'margin-bottom': margin + "px"
        });
        if (index === 0) {
          $(this).css('margin-bottom', 0);
        }
        if (index === 1) {
          $(this).css('margin-top', margin - 110);
        }
      });

      $('#page-content td').each(function () {
        if ( $(this).html().match(/<img/) === null) {
          // text only node
          $(this).addClass('text-only');
        }
      });

    },
    initialize: function () {
      $('#page-content section').wrapInner("<div class='slide'></div>");
      $('#page-content section .double-page > div').wrapInner("<div class='inner'></div>");
      this.setCSS();
    }
  }
}());

BOO.namespace("BOO.svg")
BOO.svg = (function () {
  return {
    initialize: function () {
      function supportsSVG() {
          return !! document.createElementNS && !! document.createElementNS('http://www.w3.org/2000/svg','svg').createSVGRect;
      }
      if (!supportsSVG()) {
        $('img').each(function () {
          var attr = $(this).attr('data-alt-src');
          if (typeof attr !== 'undefined' && attr !== false) {
            $(this).attr('src', $(this).attr('data-alt-src'));
          }
        })
      } else {
        $('body').addClass('svg');
      }
    }
  }
}());

BOO.namespace("BOO.views.dropdown")
BOO.views.dropdown = (function () {

  var Dropdown;

  Dropdown = function (dropdown) {

    this.isColor = function () {
      return this.$dropdown.attr('data-option') === "0";
    };

    this.isSize = function () {
      return this.$dropdown.attr('data-option') === "1";
    };

    this.toggleDropdown = function () {
      this.$dropdown.toggleClass('open');
    };

    this.setSelected = function (e) {
      var selectedOption = e.target;
      var selectedOptionName = $(selectedOption).attr('data-value');
      var $sizeDropdown = $('.dropdown[data-option="1"]');

      var $select = $('#product-select-option-' + this.$dropdown.attr('data-option')); // hidden <select> actually used by site

      var currentlySelectedSize = $('#product-select-option-1').val();

      // Short circut if the option they clicked is not available
      if ( !$(selectedOption).hasClass('available') )
        return;

      // update the UI
      this.updateUI(selectedOption);

      // update hidden <select>
      $select.val( selectedOptionName ).trigger('change');

      // Close dropdown
      this.toggleDropdown();

      if (this.isColor()) {
        // Go through Size dropdown and make active only ones that have inventory
        $('.option', $sizeDropdown).removeClass('available'); // clear existing active items

        for (var i = 0; i < window.PRODUCT_JSON.variants.length; i++) {
          var variant = window.PRODUCT_JSON.variants[i];
          if (variant.option1 === selectedOptionName) {
            if (variant.inventory_quantity > 0) {
              // <variant> has inventory
              var size = variant.option2;
              $sizeDropdown.find('.option[data-value="' + size + '"]').addClass('available');
            }
            // if the user has already selected a size but the size is out of stock, reset size dropdown
            if (variant.option2 === currentlySelectedSize && variant.inventory_quantity < 1) {
              $sizeDropdown.find('.selected').text('Select a Size');
            }
          }
        }

      }

    };

    this.setLabel = function (text) {
      this.$dropdown.find('.selected').text(text);
    };

    this.updateUI = function (selectedOption) {
      var property = ""
      if (this.isColor())
        property = "Color";
      if (this.isSize())
        property = "Size";
      this.setLabel(property + " " + $(selectedOption).text());
    };

    this.removeDuplicates = function () {
      var options = this.$dropdown.find('.option');
      var seen = {};
      this.$dropdown.find('.option').each(function() {
        var txt = $(this).text();
        if (seen[txt])
          $(this).remove();
        else
          seen[txt] = true;
      });
    };

    this.removeColorsWithNoInventory = function () {
      var colorInventorySums = {};
      if (this.isColor()) { // just double checking
        for (var i = 0; i < window.PRODUCT_JSON.variants.length; i++) {
          var variant = window.PRODUCT_JSON.variants[i];
          var color = variant.option1;
          var count = variant.inventory_quantity;
          colorInventorySums[color] = colorInventorySums[color] + count || 0;
        }
      }

      for (var colorName in colorInventorySums) {
        if (colorInventorySums.hasOwnProperty(colorName) && colorInventorySums[colorName] < 1) {
          var option = this.$dropdown.find('.option[data-value="' + colorName + '"]');
          option.remove();
        }
      }
    };

    // Init
    this.$dropdown = $(dropdown);
    this.removeDuplicates();
    // Bind Events
    this.$dropdown.find('.selected').on('click', this.toggleDropdown.bind(this));
    this.$dropdown.find('.option').on('click', this.setSelected.bind(this));
    if (this.isColor()) {
      // for each color, check if there are _any_inventory in any size.  if all sizes lack inventory, then hide the color too
      this.removeColorsWithNoInventory();

      // Select the first option.
      if (this.$dropdown.find('.option.available').length > 0) {
        this.$dropdown.find('.option.available').first().trigger('click');
        this.$dropdown.toggleClass('open'); // close it back up after triggering click
      }
    }
    // a bit of a hack to get the cart back into the disabled state after the above click
    $('#add').val('ADD TO CART').addClass('disabled').attr('disabled', 'disabled').fadeTo(0, 0.5);
  };

  Dropdown.prototype.constructor = BOO.views.dropdown;

  return Dropdown;

}());

BOO.namespace("BOO.views.collectionDropdown")
BOO.views.collectionDropdown = (function () {

  var Dropdown;

  Dropdown = function (dropdown) {

    this.toggleDropdown = function () {
      this.$dropdown.toggleClass('open');
    };

    this.setSelected = function (e) {
      var selectedOption = e.target;

      if (this.$dropdown.hasClass('sort')) {
        // Sort dropdown
        var old_url = this.$dropdown.attr('data-collection-url');
        var new_url = old_url.replace(/(best-selling|newest|price-desc|price-asc)/, $(selectedOption).attr('data-value'));
        window.location.href = new_url;
      }
    };

    this.updateUI = function (selectedOption) {
      var property = ""
      if (this.$dropdown.attr('data-option') === "0") // Color
        property = "Color";
      if (this.$dropdown.attr('data-option') === "1") // Size
        property = "Size";
      this.$dropdown.find('.selected').text(property + " " + $(selectedOption).text());
    }

    this.$dropdown = $(dropdown);
    this.$dropdown.find('.selected').on('click', this.toggleDropdown.bind(this));
    this.$dropdown.find('.option.available').on('click', this.setSelected.bind(this));
  };

  Dropdown.prototype.constructor = BOO.views.collectionDropdown;

  return Dropdown;

}());


BOO.namespace("BOO.views.quantityDropdown")
BOO.views.quantityDropdown = (function () {

  var Dropdown;

  Dropdown = function (dropdown) {

    this.toggleDropdown = function () {
      this.$dropdown.toggleClass('open');
    };

    this.setSelected = function (e) {
      var selectedOption = e.target;

      var quantity = $(e.target).attr('data-value');

      this.$dropdown.find('input').first().val(quantity);

      this.$dropdown.find('.selected').first().text(quantity);

      // Close dropdown
      this.toggleDropdown();

      // Update Cart
      $('#update-cart').trigger('click');
    };

    this.$dropdown = $(dropdown);

    var options = this.$dropdown.find('.options');
    for (var i = 0; i < 20; i++) {
      options.append('<div class="option available" data-value="' + i + '">' + i + '</div>');
    }

    this.$dropdown.find('.selected').on('click', this.toggleDropdown.bind(this));
    this.$dropdown.find('.option').on('click', this.setSelected.bind(this));

  };

  Dropdown.prototype.constructor = BOO.views.quantityDropdown;

  return Dropdown;

}());

// Size Chart
BOO.namespace("BOO.views.sizeChartModal")
BOO.views.sizeChartModal = (function () {
  return {
    openModal: function () {
      var _this = this;
      $('body').append('<div class="dimmer"></div>');
      $('#size-chart-modal').show();
      $('.dimmer, #size-chart-modal .close').one('click', function (e) {
        if (! $(e.target).hasClass('inner'))
          _this.closeModal();
      });
      $('#size-chart-modal').get(0).scrollIntoView();
    },
    closeModal: function () {
      $('.dimmer').remove();
      $('#size-chart-modal').hide();
    },
    processMenuClick: function (e) {
      var $link = $(e.target);
      var chartToShow = $link.attr('data-show');
      $('#size-chart-modal .chart-list a').removeClass('active');
      $link.addClass('active');
      $('#size-chart-modal .main-col img').hide();
      $('#size-chart-modal .main-col img').each(function() {
        if ( $(this).attr('id') == chartToShow ) {
          $(this).css('display', 'block');
        }
      });
    },
    initialize: function () {
      $('.size-chart-link').on('click', this.openModal.bind(this));
      $('.chart-list a').on('click', this.processMenuClick.bind(this))
    }
  }
}());

BOO.namespace("BOO.views.productImageSelector")
BOO.views.productImageSelector = (function () {
  return {
    $imageList: null,
    imgClicked: function (event) {
      var img = event.target;
      this.$imageList.find('img').removeClass('selected');
      $(img).addClass('selected');
      $('#main-product-image').find('img').attr('src', function () {
        return $(img).attr('data-full-url');
      })
    },
    preloadFullImages: function () {
      this.$imageList.find('img').each(function () {
        var i = new Image();
        i.src = $(this).attr('data-full-url');
      });
    },
    initialize: function (imageList) {
      this.$imageList = $(imageList);
      this.$imageList.find('img').first().addClass('selected');
      this.$imageList.find('img').on('click', this.imgClicked.bind(this));
      this.preloadFullImages();
    }
  }
}());

BOO.namespace('BOO.events.quickLook');
BOO.events.quickLook = (function () {
  return {
    open: function (e) {
      var url = $(e.target).attr('data-product-url');
      if (url) {
        $('body').append("<div class='dimmer'></div>");
        $('body').append("<div class='detail-modal'><div class='inner'><div class='closeModal'></div><iframe src='" + url + "' onload='javascript:resizeIframe(this);' /></div></div>");
        // todo: if window less than 820px tall, resize .inner
        $('.detail-modal .closeModal').one('click', this.closeModal);
        $('.dimmer, .detail-modal').one('click', this.closeModal)
                    .children().on('click', function () {
                      return false; // prevent child clicks from affecting anything
                    })
      }
    },
    closeModal: function () {
      console.log("close");
      $('.detail-modal, .dimmer').remove();
    },
    hoverAreaClicked: function (e) {
      if ($(e.target).hasClass('quick-look-hover')) {
        window.location.href = $(e.target).attr('data-product-url');
      }
    },
    initialize: function () {
      $('.quick-look-hover > div').on('click', this.open.bind(this));
      $('.quick-look-hover').on('click', this.hoverAreaClicked);
    }
  }
}());


BOO.namespace('BOO.events.archiveDetail');
BOO.events.archiveDetail = (function () {

  return {
    open: function (e) {

      e.preventDefault();

      var $img = $(e.target);

      var tags = [];
      $img.parent().find('.tags a').each(function () {
        tags.push( $(this).text() );
      });

      this.render({
        url: $img.attr('data-fullsize-image'),
        tags: tags
      });

      this.endLoading();

      this.setSideBarOffset();
      this.postOpenBindClicks();
      this.preloadImages();
      this.setArrows();
    },

    postOpenBindClicks: function () {
      // Bind Clicks
      var _this = this;
      $('.dimmer, #archive-modal .closeModal').one('click', this.closeModal);
      $('#archive-modal').on('click', function (e) {
        if ($(e.target).attr('id') === "archive-modal") {
          _this.closeModal();
        }
      });

      $('#archive-modal').on('click', '.modal-tag', this.tagClicked.bind(this));
      $('#archive-modal .next').on('click', this.goToNext.bind(this));
      $('#archive-modal .previous').on('click', this.goToPrev.bind(this));
      $('#archive-modal .share').on('click', this.shareButtonClicked.bind(this));
    },

    render: function (params) {
      $('body').append("<div class='dimmer'></div>");
      $('body').append(this.template({
        url: params.url,
        tags: params.tags,
        caption: params.caption
      }));
    },

    tagClicked: function (e) {
      var tag = $(e.target).text().substring(1); // remove #
      console.log(tag);
      $(document).trigger("filterByTag", [tag])
      this.closeModal();
    },

    closeModal: function (cb) {
      $.when( $('#archive-modal, .dimmer').remove() ).then(function () {
        if (typeof(cb) == "function") {
          cb();
        }
      });
    },

    setSideBarOffset: function () {
      return true;
      var url = $('#archive-modal').find('.main-image').attr('src');
      var img = new Image();

      img.onload = function () {
        $('#archive-modal .side-bar').css('right', function () {
          var rightSide = 545 - ( Math.min(400, img.width) / 2) - $('#archive-modal .side-bar').width() - 40; // 20 = distance
          return Math.max(0, rightSide);
        });
      }
      img.src = url;
    },

    loadedImageList: function () {
      return _.map( $('.archive-photo-img'), function (img) { return $(img).attr('data-fullsize-image'); });
    },

    setArrows: function () {
      $('#archive-modal .arrow.left').toggleClass('hidden', this.isAtBeginning());
      $('#archive-modal .arrow.right').toggleClass('hidden', this.isAtEnd());
    },

    isAtBeginning: function () {
      return this.loadedImageList().indexOf( $('#archive-modal .main-image').attr('src') ) === 0;
    },

    isAtEnd: function () {
      return this.loadedImageList().indexOf( $('#archive-modal .main-image').attr('src') ) === this.loadedImageList().length - 1;
    },

    replaceModalContentsWithContentsOfDiv: function (archiveItem) {
      // Image
      var imageUrl = $(archiveItem).find('.archive-photo-img').attr('data-fullsize-image');
      $('#archive-modal .main-image').attr('src', imageUrl);

      // Tags
      var tags = [];
      $(archiveItem).find('.tags a').each(function () {
        tags.push( "<a class='modal-tag'>" + $(this).text() + "</a> " );
      });
      $('#archive-modal .tags').html(tags);

      // Caption
      var caption = $(archiveItem).find('.caption p').text();
      $('#archive-modal .caption').html(caption);

      this.setSideBarOffset();
      this.endLoading();
    },

    getCorrespondingItemOnPageForImage: function (fullScreenImageUrl) {
      return $('.archive-photo-img[data-fullsize-image="' + fullScreenImageUrl + '"]').parents('.archive-item');
    },

    getIndexOfCurrentElement: function (fullScreenImageUrl) {
      return $('.archive-item').index( this.getCorrespondingItemOnPageForImage( fullScreenImageUrl ) );
    },

    loadNextPageAndGoWhenLoaded: function () {
      var _this = this;
      var itemCount = $('.archive-photo-img').length;
      console.log("loadNextPageAndGoWhenLoaded - init");
      $(document).one('infiniteScrollPageLoaded', function () {
        console.log("loadNextPageAndGoWhenLoaded - infiniteScrollPageLoaded");
        if ( $('.archive-photo-img').length > itemCount ) {
          console.log("new images");
          _this.preloadImages();
          _this.goToNext();
        }
      })
      $(document).trigger('addPage');
    },

    goToNext: function () {
      console.log( "goToNext" );
      var _this = this;
      if (_this.isAtEnd()) {
        _this.loadNextPageAndGoWhenLoaded();
        return;
      }
      _this.startLoading();
      var fullScreenImageUrl = $('#archive-modal .main-image').attr('src');
      var currentElement = this.getCorrespondingItemOnPageForImage( fullScreenImageUrl );

      if (currentElement.find('.archive-photo-img').length > 1) {
        // multi image post
        currentElement.find('.archive-photo-img').each( function (index, img) {
          // find which one of these we're currently at
          if (fullScreenImageUrl === $(img).attr('data-fullsize-image')) {
            // Image found
            if (index !== currentElement.find('.archive-photo-img').length - 1) {
              // Not at the last image, just replace image
              var nextImage = $( currentElement.find('.archive-photo-img').get(index + 1) );
              if (nextImage) {
                $('#archive-modal .main-image').attr('src', nextImage.attr('data-fullsize-image'));
                _this.endLoading();
              } else {
                _this.loadNextPageAndGoWhenLoaded();
              }
            } else {
              // At last image in a series, go to next div as normal
              var currentIndex = _this.getIndexOfCurrentElement( fullScreenImageUrl );
              var next = $('.archive-item').get(currentIndex+1);
              if (next) {
                _this.replaceModalContentsWithContentsOfDiv( next );
              } else {
                _this.loadNextPageAndGoWhenLoaded();
              }
            }
          }
        });
      } else {
        // single image post
        var currentIndex = _this.getIndexOfCurrentElement( fullScreenImageUrl );
        var next = $('.archive-item').get(currentIndex+1);
        if (next) {
          _this.replaceModalContentsWithContentsOfDiv( next );
        }
      }
    },

    goToPrev: function () {
      console.log( "goToPrev" );
      var _this = this;
      if (_this.isAtBeginning()) {
        return;
      }
      _this.startLoading();
      var fullScreenImageUrl = $('#archive-modal .main-image').attr('src');
      var currentElement = this.getCorrespondingItemOnPageForImage( fullScreenImageUrl );

      if (currentElement.find('.archive-photo-img').length > 1) {
        // multi image post
        currentElement.find('.archive-photo-img').each( function (index, img) {
          // find which one of these we're currently at
          if (fullScreenImageUrl === $(img).attr('data-fullsize-image')) {
            // Image found
            if (index !== 0) {
              // Not at the last image, just replace image
              var prevImage = $( currentElement.find('.archive-photo-img').get(index - 1) );
              $('#archive-modal .main-image').attr('src', prevImage.attr('data-fullsize-image'));
              _this.endLoading();
            } else {
              // At last image in a series, go to prev div as normal
              var currentIndex = _this.getIndexOfCurrentElement( fullScreenImageUrl );
              var prev = $('.archive-item').get(currentIndex - 1);
              if (prev) {
                _this.replaceModalContentsWithContentsOfDiv( prev );
              }
            }
          }
        });
      } else {
        // single image post
        var currentIndex = _this.getIndexOfCurrentElement( fullScreenImageUrl );
        if (currentIndex > 0) {
          var prev = $('.archive-item').get(currentIndex - 1);
          _this.replaceModalContentsWithContentsOfDiv( prev );
        }
      }
    },

    shareButtonClicked: function () {
      var image_url = $('#archive-modal .main-image').attr('src');
      var caption = $('#archive-modal .tags').text();
      var tags = "bandofoutsiders," + $('#archive-modal .tags').text().replace(/\#/g, ",");
      window.open("http://www.tumblr.com/share/photo?source=" + encodeURIComponent( image_url ) + "&caption=" + encodeURIComponent( caption ) + "&clickthru=" + encodeURIComponent( window.location.href ) + "&tags=" + encodeURIComponent(tags),'sharer','toolbar=0,status=0,width=480,height=480');
    },

    startLoading: function () {
      $('#archive-modal .main-image-wrapper').addClass('image-loading');
    },

    endLoading: function () {
      this.setArrows();
      $('#archive-modal .main-image-wrapper').removeClass('image-loading');
    },

    preloadImages: function () {
      $('.archive-photo-img').each(function () {
        var img = new Image();
        img.onload = function () {};
        img.src = $(this).attr('data-fullsize-image');
      });
    },

    bindClicks: function () {
      $('body').on('click', '.archive-item img', this.open.bind(this));
    },

    initialize: function () {
      var _this = this;
      this.bindClicks()

      this.template = Handlebars.compile($('#archive-modal-template').html());

      // Bind Keys
      $(document).keydown(function(e){
        if (e.keyCode == 37) {
          _this.goToPrev();
          return false;
        }
        if (e.keyCode == 39) {
          _this.goToNext();
          return false;
        }
        if (e.keyCode == 27) {  // esc
          _this.closeModal();
          return false;
        }
      });
    }
  }
}());

BOO.namespace('BOO.events.feedDetail');
BOO.events.feedDetail = $.extend(true, {}, BOO.events.archiveDetail); // first, make a copy
BOO.events.feedDetail = $.extend(true, BOO.events.feedDetail, {

  open: function (e) {

    e.preventDefault();

    var $img = $(e.target);

    this.render({
      url: $img.attr('data-fullsize-image'),
      caption: $img.parents('.feed-item.photo').find('.caption p').text()
    });

    this.setSideBarOffset();
    this.postOpenBindClicks();
    this.endLoading();
  },

  getCorrespondingItemOnPageForImage: function (fullScreenImageUrl) {
    return $('.feed-item.photo img[data-fullsize-image="' + fullScreenImageUrl + '"]').parents('.feed-item');
  },

  goToNext: function () {
    var _this = this;
    if (_this.isAtEnd()) {
      _this.loadNextPageAndGoWhenLoaded();
      return;
    }
    _this.startLoading();
    var fullScreenImageUrl = $('#archive-modal .main-image').attr('src');
    var currentElement = this.getCorrespondingItemOnPageForImage( fullScreenImageUrl );

    $('.feed-item.photo').each(function (index, feedItem) {
      if ( currentElement.find('img').attr('data-fullsize-image') === $(feedItem).find('img').attr('data-fullsize-image') ) {
        // we're on our current image
        if ( index < $('.feed-item.photo').length - 1) {
          _this.replaceModalContentsWithContentsOfDiv( $( $('.feed-item.photo').get(index + 1) ) );
        } else {
          _this.loadNextPageAndGoWhenLoaded();
        }
      }
    });
  },

  goToPrev: function () {
    var _this = this;
    if (_this.isAtBeginning()) {
      return;
    }
    _this.startLoading();
    var fullScreenImageUrl = $('#archive-modal .main-image').attr('src');
    var currentElement = this.getCorrespondingItemOnPageForImage( fullScreenImageUrl );

    $('.feed-item.photo').each(function (index, feedItem) {
      if ( currentElement.find('img').attr('data-fullsize-image') === $(feedItem).find('img').attr('data-fullsize-image') ) {
        // we're on our current image
        if ( index > 0) {
          _this.replaceModalContentsWithContentsOfDiv( $( $('.feed-item.photo').get(index - 1) ) );
        }
      }
    });
  },

  shareButtonClicked: function (e) {
    var url = $(e.target).parents('.archive-modal').find('img').attr('src');
    var feedItem = this.getCorrespondingItemOnPageForImage( url );
    feedItem.find('.share.photo').trigger('click');
  },

  bindClicks: function () {
    $('body').on('click', '.feed-item.photo img', this.open.bind(this));
  },

});

// Handlebars Helpers

Handlebars.registerHelper('feedImage', function(alt_sizes) {
  // Get first sub-400px wide image
  var item = _.find(alt_sizes, function (size) { return size.width < 400 });
  return new Handlebars.SafeString(
    item.url
  );
});

Handlebars.registerHelper('archiveImage', function(alt_sizes) {
  // Get first sub-400px wide image
  var item = _.find(alt_sizes, function (size) { return size.width <= 400 });
  return new Handlebars.SafeString(
    item.url
  );
});

Handlebars.registerHelper('archiveFullSizeImage', function(alt_sizes) {
  // Get largest image in the bunch.
  var item = _.max(alt_sizes, function (size) { return size.height });
  return new Handlebars.SafeString(
    item.url
  );
});


Handlebars.registerHelper('vimeoEmbed', function(players) {
  // Resize to 275 wide
  var item = _.findWhere(players, {width: 500});
  var $embed = $(item.embed_code);
  var orig_width = $embed.attr('width') * 1.0;
  var orig_height = $embed.attr('height') * 1.0;
  var new_width = 275;
  var height_width_ratio = orig_height / orig_width;
  var new_height = new_width * height_width_ratio;
  $embed.attr('height', new_height);
  $embed.attr('width', new_width);
  return new Handlebars.SafeString(
    $embed.prop('outerHTML')
  );
});

$(document).ready(function () {
  Handlebars.registerHelper('timeAgo', function(tumblerTimestamp) {
    var unixTime = tumblerTimestamp * 1000;
    if ($.timeago) {
      return new Handlebars.SafeString($.timeago(unixTime));
    } else {
      return new Handlebars.SafeString("");
    }
  });
});

Handlebars.registerHelper('externalLink', function(post) {
  if (post.link_url) {
    return new Handlebars.SafeString(
      post.link_url
    );
  } else {
    return new Handlebars.SafeString(
      "javascript:"
    );
  }
});

Handlebars.registerHelper('sharableImage', function(post) {
  return new Handlebars.SafeString(
    post.photos[0].original_size.url
  );
});

Handlebars.registerHelper('viaString', function(post) {

  if (post.link_url && post.link_url.match(/instagram.com/) !== null) {
    return new Handlebars.SafeString(
      "via Instagram"
    );
  }

  if (post.link_url && post.link_url.match(/phhhoto.com/) !== null) {
    return new Handlebars.SafeString(
      "via PHHHOTO"
    );
  }

  if (post.type === "video" && post.permalink_url && post.permalink_url.match(/vimeo.com/) !== null) {
    return new Handlebars.SafeString(
      "via Vimeo"
    );
  }

  return new Handlebars.SafeString(
    ""
  );

});


// Misc
var BrowserDetect =
{
    init: function ()
    {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) ||       this.searchVersion(navigator.appVersion) || "Unknown";
    },

    searchString: function (data)
    {
        for (var i=0 ; i < data.length ; i++)
        {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) != -1)
            {
                return data[i].identity;
            }
        }
    },

    searchVersion: function (dataString)
    {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
    },

    dataBrowser:
    [
        { string: navigator.userAgent, subString: "Chrome",  identity: "Chrome" },
        { string: navigator.userAgent, subString: "MSIE",    identity: "Explorer" },
        { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
        { string: navigator.userAgent, subString: "Safari",  identity: "Safari" },
        { string: navigator.userAgent, subString: "Opera",   identity: "Opera" }
    ]

};
BrowserDetect.init();

function resizeIframe(obj) {
  obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
}

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};


/*
BOO.namespace("BOO.views.")
BOO.views. = (function () {
  return {
    initialize: function () {

    }
  }
}());
*/
